import React from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import VideoSection from "@/components/VideoSection";
import ServicesSection from "@/components/ServicesSection";
import PricingSection from "@/components/PricingSection";
import ColorSelector from "@/components/ColorSelector";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PromoBanner from "@/components/PromoBanner";
import AboutSection from "@/components/AboutSection";
import FAQSection from "@/components/FAQSection";
import QuoteSection from "@/components/QuoteSection";
import MapSection from "@/components/MapSection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Dominican Upholstered",
  "description": "Luxury commercial and residential upholstery. Custom booths, restaurant seating, and furniture in Elizabeth, NJ.",
  "url": "https://dominicanupholstered.com",
  "telephone": "+19732883496",
  "email": "dominicanupholstered.nj@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "1045 North Broad St.",
    "addressLocality": "Elizabeth",
    "addressRegion": "NJ",
    "postalCode": "07208",
    "addressCountry": "US"
  },
  "geo": { "@type": "GeoCoordinates", "latitude": 40.6795, "longitude": -74.2157 },
  "openingHoursSpecification": [
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "08:00", "closes": "18:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "09:00", "closes": "15:00" }
  ],
  "priceRange": "$$",
  "image": "/logo.png",
  "sameAs": [
    "https://www.instagram.com/dominican_upholstered_nj?igsh=bnN4cXFxYnNleXQ0",
    "https://www.facebook.com/share/1CZrwp2ESR/",
    "https://www.youtube.com/@Dominicanupholstered9906"
  ]
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="home-page">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <VideoSection />
        <ServicesSection />
        <PricingSection />
        <ColorSelector />
        <GallerySection />
        <TestimonialsSection />
        <PromoBanner />
        <AboutSection />
        <FAQSection />
        <QuoteSection />
        <MapSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
